var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo } from 'react';
import { apiGetOneConsultantSearchEachCountInquiryThemes } from '@/actions/ConsultantSearchActions';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { SESSION_STORAGE_KEY_TOP_THEME_LIST } from '@/utils/constants/storage/sessionStorageKey';
import { stringifyUrl } from '@/utils/libs/query-string/stringify';
import { useSessionStorage } from '@/utils/libs/react-hookz/useSessionStorage';
import { consultantSearchPath, caseListPath } from '@/utils/router/links';
/**
 * ご相談いただけるテーマの情報を取得するカスタムフック
 */
export const useTopPageFetchTheme = (options) => {
    const { dispatch } = options;
    // テーマのデータを保存
    const { set: setThemeList, value: themeList } = useSessionStorage(SESSION_STORAGE_KEY_TOP_THEME_LIST, {
        defaultValue: undefined,
    });
    /**
     * テーマ情報取得
     */
    const fetchTheme = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetOneConsultantSearchEachCountInquiryThemes({}, {}));
        // 取得したデータを sessionStorage に保存
        setThemeList(payload);
    }), [dispatch, setThemeList]);
    /**
     * 整形したテーマのデータ
     */
    const formattedThemeList = useMemo(() => themeList === null || themeList === void 0 ? void 0 : themeList.map((theme) => {
        var _a, _b;
        return ({
            caseLinkTo: stringifyUrl({
                query: {
                    category: theme.support_example_category_id,
                },
                url: caseListPath(),
            }),
            iconImage: {
                src: ((_b = (_a = theme.thumbnail_picture) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.src) || '',
            },
            label: theme.name,
            professionalsCount: theme.professionals_count,
            professionalsLinkTo: stringifyUrl({
                query: {
                    keyword: theme.keyword,
                    search: 'search',
                },
                url: consultantSearchPath(),
            }),
            rfpsCount: theme.rfps_count,
        });
    }), [themeList]);
    return {
        fetchTheme,
        themeList: formattedThemeList,
    };
};
